import { composeProps, createPropsExtender } from '@mews/framework';
import { getReservationCustomerIds } from '@mews-commander/legacy-entities/src/ducks/reservations';
import { getCustomersTotalBalance } from '../../../ducks/balances';

export const getReservationsTotalBalance = composeProps(
    getCustomersTotalBalance,
    createPropsExtender('ids', getReservationCustomerIds)
);
